import * as Actions from './type';
import {
  createVehicleApi,
  updateVehicleApi,
  getVehicleList,
  getSignleVehicle,
  exportVehicleApi,
  getvehicleImagesApi,
  deleteVehicleApi,
  searchVehicleApi,
  importVehicleApi,
} from '../../api/vehicle/vehicle-api';
import { Toast } from '../../components/Toast/Toast';

export const createVehicle = (vehicleData) => async (dispatch) => {
  try {
    dispatch({
      type: Actions.CREATE_VEHICLE_REQUEST,
    });
    const { data } = await createVehicleApi(vehicleData);
    dispatch({
      type: Actions.CREATE_VEHICLE_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: Actions.CREATE_VEHICLE_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const updateVehicle = (vehicleData) => async (dispatch) => {
  try {
    dispatch({
      type: Actions.UPDATE_VEHICLE_REQUEST,
    });
    const { data } = await updateVehicleApi(vehicleData);
    dispatch({
      type: Actions.UPDATE_VEHICLE_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: Actions.UPDATE_VEHICLE_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const deleteVehicle = (id) => async (dispatch) => {
  try {
    dispatch({
      type: Actions.DELETE_VEHICLE_REQUEST,
    });
    const { data } = await deleteVehicleApi(id);
    dispatch({
      type: Actions.DELETE_VEHICLE_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: Actions.DELETE_VEHICLE_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const VehicleList = (query) => async (dispatch) => {
  try {
    dispatch({
      type: Actions.GET_VEHICLE_LISTING_REQUEST,
    });
    const { data } = await getVehicleList(query);
    dispatch({
      type: Actions.GET_VEHICLE_LISTING_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: Actions.GET_VEHICLE_LISTING_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const VehicleSingle = (id) => async (dispatch) => {
  try {
    dispatch({
      type: Actions.GET_VEHICLE_REQUEST,
    });
    const { data } = await getSignleVehicle(id);
    dispatch({
      type: Actions.GET_VEHICLE_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: Actions.GET_VEHICLE_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const exportVehicle = (query) => async (dispatch) => {
  try {
    dispatch({
      type: Actions.EXPORT_VEHICLE_REQUEST,
    });
    const { data } = await exportVehicleApi(query);
    dispatch({
      type: Actions.EXPORT_VEHICLE_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: Actions.EXPORT_VEHICLE_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const getvehicleImages = (vehicle) => async (dispatch) => {
  const { data } = await getvehicleImagesApi(vehicle.id);
  dispatch({
    type: Actions.UPDATE_VEHICLE_IMAGES,
    payload: data,
  });
};

export const searchVehicle = (_data) => async (dispatch) => {
  try {
    dispatch({
      type: Actions.SEARCH_VEHICLE_REQUEST,
    });
    const { data } = await searchVehicleApi(_data);
    dispatch({
      type: Actions.SEARCH_VEHICLE_SUCCESS,
      payload: data,
    });
  } catch (error) {
    const message =
      error.response && error.response.data.message
        ? error.response.data.message
        : error.message;

    Toast('error', message);
    dispatch({
      type: Actions.SEARCH_VEHICLE_FAIL,
      payload: message,
    });
  }
};

export const importVehicle =
  (file, handleUploadProgress) => async (dispatch) => {
    const formData = new FormData();
    formData.append('file', file?.[0]);

    try {
      dispatch({
        type: Actions.IMPORT_VEHICLE_REQUEST,
      });
      const { data } = await importVehicleApi(formData, handleUploadProgress);
      dispatch({
        type: Actions.IMPORT_VEHICLE_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: Actions.IMPORT_VEHICLE_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };
